var OplevMere = OplevMere || {};

OplevMere.navigation = OplevMere.navigation || function () {

    this.init = function() {
		toggleMobileNavigation();
		subNavigation();
	};

	this.toggleMobileNavigation = function(){
		if ($('#js-main-navigation').length > 0) {
			$('#js-mobile-navigation-trigger, #js-mobile-navigation-close').on('click', function(){
				if (!$('#js-main-navigation').hasClass('js-active')) {
					$('#js-main-navigation').addClass('js-active');
					$('body').addClass('mobile-nav-open');
				}
				else {
					$('#js-main-navigation').removeClass('js-active');
					$('body').removeClass('mobile-nav-open');
				}
			}); 
		}
	};

	this.subNavigation = function(){
		if( $('#js-main-navigation').length) {
			var subToggle = $('.js-sub-navigation-trigger');
			subToggle.on('click', function(e){
				e.preventDefault();
				e.stopPropagation();
				$(this).parent().siblings('ul').slideToggle(100);
			});
		}
	};

    return {
		init : init,
        toggleMobileNavigation : toggleMobileNavigation,
		subNavigation : subNavigation
	};

}();